import React, { FC, useMemo } from 'react';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useController } from 'react-hook-form';
import classNames from 'classnames';
import CreatableSelect from 'react-select/creatable';

import { generateSelectStyles } from '@buyside/components/presentation/Fields/selectField';

import { labelize } from '@buyside/util/arrayHelper';

import fieldStyles from '@buyside/components/presentation/Fields/fieldStyles.scss';

const TagListField: FC = () => {
  const {
    field: { name, onBlur, onChange, ref, value },
    fieldState: { error },
    formState: { isSubmitting }
  } = useController({ name: 'tagList' });

  const selectStyles = useMemo(
    () => generateSelectStyles({ error: Boolean(error), size: 'medium' }),
    [error]
  );

  return (
    <div className={classNames(fieldStyles.field, fieldStyles.medium)}>
      <label data-title>Keyword Tags</label>
      <CreatableSelect
        classNamePrefix={name}
        components={{ DropdownIndicator: null }}
        formatCreateLabel={inputValue => inputValue}
        formatOptionLabel={({ label }) => `#${label}`}
        isDisabled={isSubmitting}
        isMulti
        onBlur={onBlur}
        onChange={options => onChange(options.map(option => option.value))}
        onCreateOption={inputValue => onChange([...value, inputValue])}
        noOptionsMessage={({ inputValue }) =>
          inputValue
            ? `#${inputValue} is already added`
            : 'Type in a keyword tag then select or press enter'
        }
        openMenuOnFocus={false}
        placeholder="Type and select..."
        ref={ref}
        styles={selectStyles as any}
        value={labelize(value)}
      />
      {error ? (
        <label data-error>
          <FontAwesomeIcon icon={faExclamationCircle} />
          {error.message}
        </label>
      ) : null}
    </div>
  );
};

export default TagListField;
